import * as React from 'react'

import DividerComp from '../../components/DividerComp/DividerComp'
import FeaturedItemCardGrid from '../../components/FeaturedItemCardGrid/FeaturedItemCardGrid'
import type { FeaturedItemsCardViewModel } from '../../view-models/FeaturedItemsCardViewModel'
import styles from './featuredItems-style.css'
import Heading from '@/components/Heading/Heading'

type Props = {
  items: Array<FeaturedItemsCardViewModel>
  heading?: string
  hideDivider?: boolean
}
type State = {}

class FeaturedItems extends React.Component<Props, State> {
  static displayName = 'FeaturedItems'
  static defaultProps = {}

  render() {
    const { items, heading, hideDivider } = this.props

    return (
      <div className={styles.featuredItemGrid}>
        {heading && (
          <div className={styles.headingWrapper}>
            <Heading level={2} tag={'h2'}>
              {heading}
            </Heading>
          </div>
        )}

        <FeaturedItemCardGrid
          items={items}
          eventName={'pension-fremhavede-sider'}
        />

        {!hideDivider && <DividerComp />}
      </div>
    )
  }
}

export default FeaturedItems
